import { render } from "./TableSelect.vue?vue&type=template&id=216f9ec8&scoped=true&ts=true"
import script from "./TableSelect.vue?vue&type=script&lang=ts"
export * from "./TableSelect.vue?vue&type=script&lang=ts"

import "./TableSelect.vue?vue&type=style&index=0&id=216f9ec8&lang=scss&scoped=true"

import exportComponent from "/builds/digitalsign/frontendweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-216f9ec8"]])

export default __exports__